import styled from "styled-components";
import IconActionButton from "basicComponents/IconActionButton/IconActionButton";
import * as PropTypes from "prop-types";

export const PADDING = 8;

export function TableButton({
  iconButtonText,
  customHeight,
  onClick,
  noResultButtonId,
  fullWidth,
  customWidth,
  customPadding,
  customIconScale,
  textAlignLeft,
  dataCy,
}) {
  return (
    <ButtonWrapper customPadding={customPadding || 0} data-cy={dataCy}>
      <IconActionButton
        customIconScale={customIconScale}
        id={noResultButtonId}
        equalPadding
        fullWidth={fullWidth}
        customHeight={customHeight}
        onClick={onClick}
        customWidth={customWidth}
        textAlignLeft={textAlignLeft}
        customBorderRadius={'32px'}
      >
        {iconButtonText}
      </IconActionButton>
    </ButtonWrapper>
  );
}

TableButton.propTypes = {
  iconButtonText: PropTypes.any,
  customHeight: PropTypes.string,
  onClick: PropTypes.func,
  noResultButtonId: PropTypes.string,
  fullWidth: PropTypes.bool,
  customWidth: PropTypes.string,
  customPadding: PropTypes.number,
  customIconScale: PropTypes.number,
  textAlignLeft: PropTypes.bool,
  dataCy: PropTypes.string,
};

const ButtonWrapper = styled.div`
  width: 100%;
  padding: ${PADDING}px ${PADDING}px ${({ customPadding }) => customPadding}px;
`;
